import { QueryKeys, ThreeMinutes } from "@Constants";
import { useQuery } from "@tanstack/react-query";
import QuestionnaireService from "@Services/QuestionnaireService";
import { isPresent } from "@Utils";

const questionnaireService = new QuestionnaireService();

const useQuestionnaireSelection = () => {
    const { data: questionnaires } = useQuery([QueryKeys.QuestionnaireList], questionnaireService.getQuestionnaires, {
        staleTime: ThreeMinutes,
        refetchOnWindowFocus: false,
    });

    const questionnaireMinimal = questionnaires?.isSuccess ? questionnaires.value.questionnaires : [];
    const filtered = questionnaireMinimal?.filter((q) => q);
    const hasQuestionnaires = isPresent(filtered);

    return {
        questionnaireMinimal,
        canShowSelect: hasQuestionnaires,
    };
};

export default useQuestionnaireSelection;
